<template>
  <div class="formContainer">
    <a-form :form="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }" @submit="handleSubmit">
      <a-row>
        <a-col :span="24">
          <a-form-item
            label="类路径"
            hasFeedback
          >
            <a-input
              placeholder="请输入类路径"
              id="clazz"
              autocomplete="off"
              :disabled="!isEdit"
              v-decorator="['clazz', { rules: [{ required: true, message: '请输入类路径！' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="占位符"
            hasFeedback
          >
            <a-input
              placeholder="请输入占位符"
              id="code"
              autocomplete="off"
              :disabled="type!='add'"
              v-decorator="['code', { rules: [{ required: true, message: '请输入占位符！' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="方法名"
            hasFeedback
          >
            <a-input
              placeholder="请输入方法名"
              id="method"
              autocomplete="off"
              :disabled="!isEdit"
              v-decorator="['method', { rules: [{ required: true, message: '请输入方法名！' }] }]"/>
          </a-form-item>
        </a-col>
        <!--        <a-col :span="8">-->
        <!--          <a-form-item-->
        <!--            :labelCol="labelCol"-->
        <!--            :wrapperCol="wrapperCol"-->
        <!--            label="优先级"-->
        <!--            hasFeedback-->
        <!--          >-->
        <!--            <a-input-->
        <!--              placeholder="请输入优先级"-->
        <!--              id="priority"-->
        <!--              :disabled="!isEdit"-->
        <!--              v-decorator="['priority', { rules: [{ required: true, message: '请输入优先级！' }] }]"/>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <!--        <a-col :span="8">-->
        <!--          <a-form-item-->
        <!--            :labelCol="labelCol"-->
        <!--            :wrapperCol="wrapperCol"-->
        <!--            label="替换规则"-->
        <!--            hasFeedback-->
        <!--          >-->
        <!--            <a-input-->
        <!--              placeholder="请输入替换规则"-->
        <!--              id="sentence"-->
        <!--              :disabled="!isEdit"-->
        <!--              v-decorator="['sentence', { rules: [{ required: true, message: '请输入替换规则！' }] }]"/>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <!--        <a-col :span="8">-->
        <!--          <a-form-item-->
        <!--            :labelCol="labelCol"-->
        <!--            :wrapperCol="wrapperCol"-->
        <!--            label="占位符类型"-->
        <!--            hasFeedback-->
        <!--          >-->
        <!--            <a-select-->
        <!--              :allowClear="true"-->
        <!--              mode="multiple"-->
        <!--              placeholder="请选择占位符类型"-->
        <!--              @change="handleChange"-->
        <!--              :disabled="!isEdit"-->
        <!--              v-decorator="['type', { rules: [{ required: true, message: '请选择占位符类型！' }] }]"-->
        <!--            >-->
        <!--              <a-select-option v-for="(item,index) in typeList" :key="index" >-->
        <!--                {{ item.label }}-->
        <!--              </a-select-option>-->
        <!--            </a-select>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <!--        <a-col :span="8">-->
        <!--          <a-form-item-->
        <!--            :labelCol="labelCol"-->
        <!--            :wrapperCol="wrapperCol"-->
        <!--            label="值"-->
        <!--            hasFeedback-->
        <!--          >-->
        <!--            <a-input-->
        <!--              placeholder="请输入值"-->
        <!--              id="value"-->
        <!--              :disabled="!isEdit"-->
        <!--              v-decorator="['value', { rules: [{ required: true, message: '请输入值！' }] }]"/>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->

        <a-col :span="24" v-show="type==='add'|| type==='edit'">
          <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit">
            <template v-if="$auth('datapermission.modifyPlaceholder')">
              <a-button type="primary" html-type="submit" style="margin-right:10px;">
                保存
              </a-button>
              <a-button style="margin-right:10px;" @click="clearForm">
                取消
              </a-button>
            </template>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
// import { getTimetableList } from '@/api/timetable'
// import { getLinesList } from '@/api/lineVehicle'
import { insertPlaceholder } from '@/api/placeholder'

export default {
  name: 'ZmForm',
  mounted () {
    // this.initData()
  },
  data () {
    return {
      isEdit: true,
      model: {},
      lineList: [],
      timeTable: [],
      itemSpan: 8,
      type: 'add',
      form: this.$form.createForm(this, { name: 'config' }),
      labelCol: {
        xs: { span: 6 },
        sm: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 24 }
      }
    }
  },
  methods: {
    initData () {
      // 初始化线路
      // getLinesList({
      //   paging:false
      // }).then(res=>{
      //   if(res.status===0){
      //     this.lineList = res.data
      //   }else{
      //     this.$message.warning('获取线路失败')
      //     this.lineList = []
      //   }
      // }).catch(error=>{
      //   console.log(error)
      //   this.$message.warning('获取线路失败')
      //   this.lineList = []
      // })
      // 初始化时刻表
      // getTimetableList({
      //   paging:false
      // }).then(res=>{
      //   if(res.status===0){
      //     this.timeTable = res.data
      //   }else{
      //     this.$message.warning('获取列车时刻表失败')
      //     this.timeTable = []
      //   }
      // }).catch(error=>{
      //   console.log(error)
      //   this.$message.warning('获取列车时刻表失败')
      //   this.timeTable = []
      // })
    },
    setType (type) {
      this.type = type
    },
    // 清空表单
    clearForm () {
      this.model = {}
      this.type = 'add'
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },
    // 设置初始值
    setValue (item) {
      this.model = item
      this.$nextTick(() => {
        this.form.setFieldsValue(item)
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          console.log('this', this)
          // 占位符类型 默认2
          params.type = 2
          delete params.sentence
          delete params.priority
          delete params.value
          if (this.type === 'add') {
            delete params.id
            insertPlaceholder(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.clearForm()
                this.$emit('refreshTree')
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === 'edit') {
            insertPlaceholder(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.clearForm()
                this.$emit('refreshTree')
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>
